import { useParams } from "react-router-dom";
import BasicTable from "@/components/BasicTable";
import { useTranslation } from "react-i18next";
import { TABLEPAI } from "@/enums/pageEnum";
import { AlarmRbeColumns, RbeStatuses } from "@/utils/commonConfig";
import { Tabs } from "antd";
import { useMemo } from "react";
import MonitoringPanel from "./MonitoringPanel";

const AlarmComponet = ({
  editTableHeaderUrl,
  isLmdlink,
  isLiftlink,
  rbeApiCode,
}: {
  editTableHeaderUrl: string;
  rbeApiCode: string;
  isLmdlink?: boolean;
  isLiftlink?: boolean;
  data?: any;
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const filterComls: any = useMemo(() => {
    return [
      {
        field: "alarmStatus",
        label: t("rbeStatus"),
        component: "select",
        options: RbeStatuses(t),
        fieldProps: { style: { width: 180 } },
      },
      {
        field: "types",
        label: t("alarm"),
        apiUrl: rbeApiCode,
        fieldProps: {
          mode: "multiple",
          style: { width: 180 },
          maxTagCount: "responsive",
        },
        component: "apiSelect",
      },
      { field: "date", label: t("setTime"), component: "timeRange" },
    ];
  }, [t, rbeApiCode]);
  return (
    <Tabs
      className="alarmTabs"
      defaultActiveKey="1"
      destroyInactiveTabPane
      items={[
        {
          key: "1",
          label: t("monitoringPanel"),
          children: <MonitoringPanel />,
        },
        {
          key: "2",
          label: t("alarmList"),
          children: (
            <BasicTable
              isShowCheckbox={false}
              filterTableFields={filterComls}
              tableColsRender={[
                ...AlarmRbeColumns({ t, isLmdlink, isLiftlink }),
              ]}
              headerTitle={() => t("alarmList")}
              tableName="alarm/device"
              longPolling
              className="min-h-[calc(100vh-371px)]"
              editTableHeaderUrl={editTableHeaderUrl}
              requestUrl={`${TABLEPAI.ALARM_DEVICE}?deviceId=${id}`}
            />
          ),
        },
      ]}
      onChange={() => {}}
    />
  );
};

export default AlarmComponet;
